import type { Dispatch, MutableRefObject, SetStateAction } from 'react'
import type { ParsedUrlQuery } from 'node:querystring'

// TODO: inline
export const setFilterQuery = <T>({
  queryRef,
  filterKeys,
  setFilter,
}: {
  queryRef: MutableRefObject<ParsedUrlQuery>
  filterKeys: MutableRefObject<(keyof T)[]>
  setFilter: Dispatch<SetStateAction<T>>
}): void => {
  const filter = {} as T
  const query = { ...queryRef.current } as T & Record<string, string | string[] | undefined>
  for (const el of filterKeys.current) {
    //for predefined selector
    if (query[el] === '') filter[el] = undefined as unknown as T[keyof T]
    if (query[el]) {
      filter[el] = Number.isNaN(Number(query[el]))
        ? query[el]
        : (Number(query[el]) as unknown as T[keyof T])
    }
  }

  setFilter(prev => ({ ...prev, ...filter }))
}
